import _toConsumableArray from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import auth from '@/utils/auth';
import TabBar from '@/base/TabBar';
import MandateAccount from '@/components/MandateAccount';
import NoticeBar from '@/views/home/components/NoticeBar';
import { CURRENT_SECONDARY_BRAND } from '@/config';
import SkinChange from '@/components/SkinChange/index';
import { BRAND_TAB_BAR, MAIN_TAB_BAR } from '@/base/constant';
var THEME_COLORS = ['light', 'dark'];
export default {
  name: 'App',
  components: {
    TabBar: TabBar,
    MandateAccount: MandateAccount,
    SkinChange: SkinChange,
    NoticeBar: NoticeBar
  },
  data: function data() {
    return {
      // showGuide: false,
      hasMain: false,
      active: 0,
      tabBars: _toConsumableArray(BRAND_TAB_BAR),
      vueAppEnv: process.env.VUE_APP_ENV,
      isOriginFromBrand: false,
      newYearSkin: ''
    };
  },
  computed: {
    hasWeiChat: function hasWeiChat() {
      return this.$Utils.isBrowser().isWechat;
    }
  },
  watch: {
    $route: function $route() {
      this.handleSetRoute();

      if (window._czc) {
        var location = window.location;
        var contentUrl = location.pathname + location.hash;
        var refererUrl = '/';

        window._czc.push(['_trackPageview', contentUrl, refererUrl]);
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.handleBrandTab();
  },
  created: function created() {
    var _this = this;

    this.$GetActivity(null).then(function (res) {
      var list = res.data;

      if (list) {
        // 新年换肤
        var newYear = list.find(function (x) {
          return x.type === 'NEW_YEAR_SKIN' && x.hasOpen;
        }); // 黑白色

        _this.grayscale = list.some(function (x) {
          return x.type === 'BLACK_WHITE_SKIN' && x.hasOpen;
        });

        _this.handleSetGrayTheme();

        if (newYear) {
          _this.newYearSkin = 'newYear';
        }

        _this.$store.commit('app/SET_SKIN_CHANGE', newYear ? 'newYear' : '');

        _this.$store.commit('app/SET_ACTIVITIES_INFO', list);

        _this.$Utils.setSessionStorageKey('activitiesInfo', list);
      }
    });
  },
  mounted: function mounted() {
    this.handleBrandTab();
    this.handleSetRoute();
    this.handleSetTheme(auth.getThemeColor() || 'Dark');
  },
  updated: function updated() {
    this.initApp(); // 路由上有主题配置更新

    var _this$$route$query$th = this.$route.query.theme,
        theme = _this$$route$query$th === void 0 ? '' : _this$$route$query$th;

    if (theme && THEME_COLORS.includes(theme)) {
      var color = theme.toLowerCase().replace(theme[0], theme[0].toUpperCase());
      this.handleSetTheme(color);
    }
  },
  methods: {
    // 哀悼色设置
    handleSetGrayTheme: function handleSetGrayTheme() {
      window.document.querySelector('html').style.filter = this.grayscale && window.location.pathname.includes('/home') ? 'grayscale(1)' : '';
    },
    // 设置主题色
    handleSetTheme: function handleSetTheme(color) {
      this.$store.commit('app/SET_THEME_COLOR', color);
      document.body.setAttribute('data-theme', color);
    },
    // 显示并高亮选中的tab bar
    handleSetRoute: function handleSetRoute() {
      var _this2 = this;

      this.$nextTick(function () {
        var path = _this2.$route.path;
        _this2.hasMain = _this2.tabBars.some(function (x) {
          return x.to.path === path || _this2.$route.name === x.to.name;
        });
        _this2.active = _this2.tabBars.findIndex(function (x) {
          return x.to.path === path;
        });

        _this2.handleSetGrayTheme();
      });
    },
    // 切换主题色
    handleChangeTheme: function handleChangeTheme() {
      var color = (auth.getThemeColor() || 'Dark') === 'Dark' ? 'Light' : 'Dark';
      this.handleSetTheme(color);
    },
    // 品牌馆底部tab bar不同
    handleBrandTab: function handleBrandTab() {
      if (CURRENT_SECONDARY_BRAND.storeNo) {
        var _this$$route = this.$route,
            query = _this$$route.query,
            name = _this$$route.name;
        this.tabBars = BRAND_TAB_BAR; // 二级品牌馆在专题市场不显示底部tabBar

        if (name === 'SearchResult') {
          this.hasMain = !(query.type === 'themeMarket');
        }

        return;
      }

      var _this$$route$query = this.$route.query,
          originFrom = _this$$route$query.originFrom,
          storeNo = _this$$route$query.storeNo;
      this.isOriginFromBrand = originFrom === 'brand' && !!storeNo;
      this.tabBars = this.isOriginFromBrand ? BRAND_TAB_BAR : MAIN_TAB_BAR;
    },
    // app内初始化
    initApp: function initApp() {
      // h5沉浸式时取消iphone底部安全适配
      if (this.$Utils.appInfo && this.$route.query.hideNavBar === '1') {
        var body = document.getElementsByTagName('body');

        if (body !== null && body !== void 0 && body.length) {
          body[0].style.paddingBottom = '0px';
        }
      }
    }
  }
};